import { usePathname } from "next/navigation"

export const useGetLocale = () => {
  const pathname = usePathname()
  const locale = pathname?.split("/")[1] || "ko"
  return locale
}
